import type { ISerialize } from '@/objects/ISerialize';

export class FileArchiveAccess implements ISerialize {
    public EventID: number | null;

    public FederationIds: number[];

    public OrganizerIds: number[];

    public UserIds: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number | null; FederationIds?: number[]; OrganizerIds?: number[]; UserIds?: number[] }) {
        this.EventID = values.EventID ?? null;

        this.FederationIds = values.FederationIds ?? [];

        this.OrganizerIds = values.OrganizerIds ?? [];

        this.UserIds = values.UserIds ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"FederationIds": [ ${this.FederationIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"OrganizerIds": [ ${this.OrganizerIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"UserIds": [ ${this.UserIds.map((x) => JSON.stringify(x))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of FileArchiveAccess from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        EventID?: number | null;
        FederationIds?: number[];
        OrganizerIds?: number[];
        UserIds?: number[];
    }): FileArchiveAccess {
        return new FileArchiveAccess(values);
    }

    public static _FromServerJson(json: any): FileArchiveAccess {
        return new FileArchiveAccess({
            EventID: json.EventID ?? null,
            FederationIds: json.FederationIds,
            OrganizerIds: json.OrganizerIds,
            UserIds: json.UserIds,
        });
    }

    /**
     * Creates an instance of FileArchiveAccess from another instance of FileArchiveAccess.
     * @param other The FileArchiveAccess you want to clone
     * @returns A cloned FileArchiveAccess
     */
    public static FromOther(other: FileArchiveAccess): FileArchiveAccess {
        return FileArchiveAccess._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return FileArchiveAccess.FromOther(this);
    }

    static NAME_OF_CLASS = 'FileArchiveAccess';
}
